<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <nb-card>
        <nb-card-header class="d-flex justify-content-between align-items-center">
          <h4 class="mb-0">
            <nb-icon icon="shopping-cart-outline" class="me-2"></nb-icon>
            Ecommerce Management
          </h4>
          <span class="badge badge-info">Store Manager Access</span>
        </nb-card-header>
        
        <nb-card-body>
          <!-- Loading State -->
          <div *ngIf="loading" class="text-center py-5">
            <nb-spinner size="large"></nb-spinner>
            <p class="mt-3 text-muted">Loading your stores...</p>
          </div>

          <!-- No Stores Found -->
          <div *ngIf="!loading && managerStores.length === 0" class="text-center py-5">
            <nb-icon icon="alert-triangle-outline" class="text-warning" style="font-size: 48px;"></nb-icon>
            <h5 class="mt-3">No Stores Assigned</h5>
            <p class="text-muted">You don't have any stores assigned to manage. Please contact your administrator.</p>
          </div>

          <!-- Multiple Stores - Selection Grid -->
          <div *ngIf="!loading && managerStores.length > 1">
            <div class="mb-4">
              <h5 class="text-muted">Select a store to manage its ecommerce:</h5>
            </div>
            
            <div class="row">
              <div class="col-lg-4 col-md-6 mb-4" *ngFor="let store of managerStores">
                <nb-card 
                  [class.border-success]="hasEcommerceEnabled(store)"
                  [class.border-warning]="!hasEcommerceEnabled(store)"
                  class="store-card h-100 cursor-pointer"
                  (click)="hasEcommerceEnabled(store) ? openEcommerceAdmin(store._id) : null"
                  [style.opacity]="hasEcommerceEnabled(store) ? '1' : '0.7'">
                  
                  <nb-card-body class="text-center">
                    <!-- Store Icon -->
                    <div class="store-icon mb-3">
                      <nb-icon 
                        [icon]="hasEcommerceEnabled(store) ? 'shopping-bag-outline' : 'shopping-bag'" 
                        [class]="hasEcommerceEnabled(store) ? 'text-success' : 'text-warning'"
                        style="font-size: 48px;">
                      </nb-icon>
                    </div>

                    <!-- Store Info -->
                    <h6 class="store-name mb-2">{{ store.storeName }}</h6>
                    <p class="text-muted small mb-2">{{ store.address }}</p>
                    
                    <!-- Store Status -->
                    <div class="mb-3">
                      <span class="badge" [class]="getStoreStatusClass(store)">
                        {{ getStoreStatusText(store) }}
                      </span>
                    </div>

                    <!-- Ecommerce Status -->
                    <div class="ecommerce-status">
                      <span 
                        *ngIf="hasEcommerceEnabled(store)" 
                        class="badge badge-success">
                        <nb-icon icon="checkmark-outline" class="me-1"></nb-icon>
                        Ecommerce Enabled
                      </span>
                      <span 
                        *ngIf="!hasEcommerceEnabled(store)" 
                        class="badge badge-warning">
                        <nb-icon icon="alert-triangle-outline" class="me-1"></nb-icon>
                        Ecommerce Disabled
                      </span>
                    </div>

                    <!-- Action Button -->
                    <div class="mt-3">
                      <button 
                        *ngIf="hasEcommerceEnabled(store)"
                        type="button" 
                        class="btn btn-success btn-sm w-100"
                        (click)="openEcommerceAdmin(store._id)">
                        <nb-icon icon="arrow-forward-outline" class="me-1"></nb-icon>
                        Manage Ecommerce
                      </button>
                      <button 
                        *ngIf="!hasEcommerceEnabled(store)"
                        type="button" 
                        class="btn btn-outline-warning btn-sm w-100" 
                        disabled>
                        <nb-icon icon="lock-outline" class="me-1"></nb-icon>
                        Ecommerce Disabled
                      </button>
                    </div>
                  </nb-card-body>
                </nb-card>
              </div>
            </div>
          </div>

          <!-- Instructions for disabled ecommerce -->
          <div *ngIf="!loading && managerStores.length > 0" class="mt-4">
            <nb-alert status="info">
              <nb-icon icon="info-outline" class="me-2"></nb-icon>
              <strong>Note:</strong> If ecommerce is disabled for a store, please contact your administrator to enable it in the store settings.
            </nb-alert>
          </div>
        </nb-card-body>
      </nb-card>
    </div>
  </div>
</div>